import type { FC } from "react";

import { noop } from "lodash";
import { useDispatch } from "react-redux";
import styled from "styled-components";

import { IconButton } from "@similarweb/ui-components";

import { showDurationFilterHof } from "app/actions/WebsiteAnalysisFilterActions";
import { translate } from "app/filters/i18nFilter";
import { NoDataLandscape } from "pro-features/components/NoData/src/NoData";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

interface INoDataWithCTAWrapper {
    title: string;
    subtitle: string;
    ctaKey?: string;
    onCtaClickCallback?: VoidFunction;
}

const IconButtonStyled = styled(IconButton)`
    width: fit-content;
`;

export const NoDataWithCTAWrapper: FC<INoDataWithCTAWrapper> = (props) => {
    const { ctaKey, title, subtitle, onCtaClickCallback = noop } = props;
    const dispatch = useDispatch();
    const openDatePicker = () => {
        onCtaClickCallback();
        const showDurationFilter = showDurationFilterHof(dispatch);
        showDurationFilter();
    };
    const onClick = () => {
        openDatePicker();
    };

    return (
        <FlexColumn
            gap={"16px"}
            justifyContent={"center"}
            alignItems={"center"}
        >
            <NoDataLandscape
                title={title}
                subtitle={subtitle}
            />
            <IconButtonStyled
                iconName="daily-ranking"
                iconSize="xs"
                onClick={onClick}
            >
                {ctaKey != null ? translate(ctaKey) : null}
            </IconButtonStyled>
        </FlexColumn>
    );
};
